import ActionsMenu from '../../../../../shared/components/ActionsMenu';
import ConfirmModal from '../../../../../shared/components/ConfirmModal';
import EnvioDetail from '../../../EnvioDetail';
import InfoModal from '../../../../../shared/components/InfoModal';
import MessageForm from '../../../MessageForm';
import Pagination from '@mui/material/Pagination';
import SeguimientoForm from '../../../SeguimientoForm';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { ENVIOS_API } from '../../../../../shared/services/envios';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import {
    handleUpdateShipmentState,
    updateDashboardShipmentState,
    updateShippingResults,
} from '../../../../../../../../redux/envios';
import { getActions } from './actions';
import {
    CustomTooltip,
    setErrorMessage,
} from '../../../../../shared/helpers/functionalities';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useRef, useState } from 'react';
import EnvioEstadoModal from '../EnvioEstadoModal';
import UpdateEstadoForm from '../UpdateEstadoForm';
import UpdateSeguimientoForm from '../UpdateSeguimientoForm';
import { InfoOutlined } from '@mui/icons-material';

export default function EnvioDetalleModal({
    currentDetail,
    getShippingNewPage,
    shippingResults
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const topRef = useRef(null);

    const [currentEnvio, setCurrentEnvio] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [openCancelar, setOpenCancelar] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [openRegenerate, setOpenRegenerate] = useState(false);
    const [openSeguimientoEnvio, setOpenSeguimientoEnvio] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [openUpdateState, setOpenUpdateState] = useState(false);

    const handleAction = (action, envio) => {
        if (action === 'details') {
            handleOpenInfo(envio);
        } else if (action === 'download') {
            generateThePdf(envio);
        } else if (action === 'regenerate') {
            handleOpenRegenerate(envio);
        } else if (action === 'cancel') {
            handleCancelar(envio);
        } else if (action === 'add-info') {
            handleOpenAddSeguimiento(envio);
        } else if (action === 'edit-carrier-info') {
            handleOpenAddSeguimiento(envio, 'edit');
        } else if (action === 'update-state') {
            handleOpenUpdateState(envio);
        }
    };
    const handleOpenInfo = async (envio) => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            const res = await ENVIOS_API.getDetail(envio.id);
            if (res?.success) {
                setCurrentEnvio(res.data);
                return setOpenInfo(true);
            }
            toast.error('Error al obtener el detalle del envío.');
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };
    const handleCloseOpenInfo = () => {
        setOpenInfo(false);
        setCurrentEnvio(null);
    };
    const handleCancelar = (envio) => {
        setOpenCancelar(true);
        setCurrentEnvio(envio);
    };
    const handleCloseCancelar = () => {
        setOpenCancelar(false);
        setCurrentEnvio(null);
    };

    const handleCloseAddSeguimiento = () => {
        setOpenSeguimientoEnvio(false);
        setCurrentEnvio(null);
    };
    const handleOpenAddSeguimiento = (envio, open = true) => {
        setOpenSeguimientoEnvio(open);
        setCurrentEnvio(envio);
    };
    const handleOpenRegenerate = (envio) => {
        setOpenRegenerate(true);
        setCurrentEnvio(envio);
    };
    const handleChangePage = (_event, value) => {
        setCurrentPage(value);
        if(topRef.current) {
            topRef.current.scrollIntoView({behavior: 'smooth'});
        }
        getShippingNewPage(value);
    };

    const getPaginationCount = () => {
        var totalPages =
            shippingResults?.total_items < 15
                ? 1
                : Math.ceil(shippingResults?.total_items / 15);
        return parseInt(totalPages);
    };
    const handleGoTo = (item, search) => {
        if (item === 'presupuesto') {
            dispatch({
                type: 'search/set',
                payload: { search, key: 'presupuesto' },
            });
            navigate('/presupuestos/1', { replace: true });
        } else if (item === 'incidencia') {
            dispatch({
                type: 'search/set',
                payload: { search, key: 'incidencia' },
            });
            navigate('/incidencias/1', { replace: true });
        }
    };
    const handleOpenStatus = (envio) => {
        setCurrentEnvio(envio);
        setOpenStatus(true);
    };
    const handleCloseStatus = () => {
        setCurrentEnvio(null);
        setOpenStatus(false);
    };
    const handleOpenUpdateState = (envio) => {
        setCurrentEnvio(envio);
        setOpenUpdateState(true);
    };
    const handleCloseUpdateState = () => {
        setCurrentEnvio(null);
        setOpenUpdateState(false);
    };

    const handleConfirmRegenerate = async (confirm) => {
        if (confirm) {
            try {
                dispatch({ type: 'loading/set', payload: true });
                const response = await ENVIOS_API.regenerate({
                    envio_id: currentEnvio?.id,
                });
                if (response.success) {
                    dispatch(
                        updateShippingResults({
                            id: currentEnvio.id,
                            ...response.data,
                        })
                    );
                    return toast.success(response.message);
                }
                return toast.error('Ups! Algo ha ido mal...');
            } catch (error) {
                toast.error(setErrorMessage(error));
            } finally {
                dispatch({ type: 'loading/set', payload: false });
                setOpenRegenerate(false);
                setCurrentEnvio(null);
            }
        }
    };
    const handleCancelarEnvio = async (data) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const response = await ENVIOS_API.cancel(data);
            if (!response.success) {
                return toast.error('Ups! Algo ha ido mal...');
            }

            setOpenCancelar(false);
            setCurrentEnvio(null);
            toast.success(response.message);

            updateReduxState(data, 'Cancelado');
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    const generateThePdf = async (envio) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const etiquetaResult = await ENVIOS_API.getLabel(envio?.id);
            const pdfName = envio?.codigo_transporte;
            if (etiquetaResult) {
                toast.success('Etiqueta generada correctamente!');
                const url = window.URL.createObjectURL(
                    new Blob([etiquetaResult])
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', pdfName + '.pdf');
                document.body.appendChild(link);
                link.click();
            } else {
                toast.error('Ups! Algo ha ido mal...');
            }
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };
    const handleAddSeguimientoEnvio = async (data) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const response = await ENVIOS_API.update(data);
            if (response.success) {
                setOpenSeguimientoEnvio(false);
                setCurrentEnvio(null);
                toast.success(response.message);
                return dispatch(updateShippingResults(data));
            }
            return toast.error('Ups! Algo ha ido mal...');
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    const updateReduxState = (data, newState) => {
        const { estadoId, isNacional } = currentDetail;
        if (shippingResults?.total_items <= 15) {
            dispatch(
                handleUpdateShipmentState(
                    data.id,
                    estadoId,
                    isNacional,
                    newState
                )
            );
        } else {
            getShippingNewPage(currentPage);
            dispatch(
                updateDashboardShipmentState(estadoId, isNacional, newState)
            );
        }
    };

    return (
        <div className="envio-detalle-modal w-100 d-flex flex-column align-items-end content-table">
            <div className="table-responsive">
                <table className="table">
                    <thead ref={topRef}>
                        <tr>
                            <th colSpan={2}>#</th>
                            <th className="text-center" colSpan={2}>
                                fecha
                            </th>
                            <th className="text-center" colSpan={2}>
                                remitente
                            </th>
                            <th className="text-center" colSpan={2}>
                                destinatario
                            </th>
                            <th className="text-center" colSpan={3}>
                                pieza
                            </th>
                            <th className="text-center" colSpan={2}>
                                transportista
                            </th>
                            <th className="text-center" colSpan={3}>
                                servicio
                            </th>
                            {currentDetail?.estadoNombre === 'Cancelado' && (
                                <th className="text-center" colSpan={2}>
                                    cancelación
                                </th>
                            )}
                            {!currentDetail && (
                                <th className="text-center" colSpan={2}>
                                    estado
                                </th>
                            )}
                            <th className="text-center" colSpan={2}>
                                resp
                            </th>
                            <th className="text-center" colSpan={1}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {shippingResults?.envios.map((envio) => (
                            <tr key={envio?.id}>
                                <td colSpan={2}>{envio?.codigo_transporte}</td>
                                <td className="text-center" colSpan={2}>
                                    {moment(envio?.fecha).format(
                                        'DD-MM-YYYY HH:mm'
                                    )}
                                </td>
                                <td colSpan={2}>
                                    {envio?.remitente?.proveedor_id !==
                                        null && (
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={
                                                '/proveedor/' +
                                                envio?.remitente?.proveedor_id
                                            }
                                            title="Ficha Proveedor"
                                            className="text-green text-uppercase"
                                        >
                                            {envio?.remitente?.nombre}
                                        </Link>
                                    )}
                                    {envio?.remitente?.entity_id !== null && (
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={
                                                '/cliente/' +
                                                envio?.remitente?.entity_id
                                            }
                                            title="Ficha Cliente"
                                            className="text-green text-uppercase"
                                        >
                                            {envio?.remitente?.nombre}
                                        </Link>
                                    )}
                                    {envio?.remitente?.proveedor_id === null &&
                                        envio?.remitente?.entity_id ===
                                            null && (
                                            <span className="text-uppercase">
                                                {envio?.remitente?.nombre}
                                            </span>
                                        )}
                                </td>
                                <td colSpan={2}>
                                    {envio?.destinatario?.proveedor_id !==
                                        null && (
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={
                                                '/proveedor/' +
                                                envio?.destinatario
                                                    ?.proveedor_id
                                            }
                                            title="Ficha Proveedor"
                                            className="text-green text-uppercase"
                                        >
                                            {envio?.destinatario?.nombre}
                                        </Link>
                                    )}
                                    {envio?.destinatario?.entity_id !==
                                        null && (
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={
                                                '/cliente/' +
                                                envio?.destinatario?.entity_id
                                            }
                                            title="Ficha Cliente"
                                            className="text-green text-uppercase"
                                        >
                                            {envio?.destinatario?.nombre}
                                        </Link>
                                    )}
                                    {envio?.destinatario?.proveedor_id ===
                                        null &&
                                        envio?.destinatario?.entity_id ===
                                            null && (
                                            <span className="text-uppercase">
                                                {envio?.destinatario?.nombre}
                                            </span>
                                        )}
                                </td>
                                <td colSpan={3}>{envio?.nombrePieza}</td>
                                <td className="text-center" colSpan={2}>
                                    {envio?.transportista_nombre}
                                    {envio?.venta_id && (
                                        <p
                                            className="m-0"
                                            onClick={() =>
                                                handleGoTo(
                                                    'presupuesto',
                                                    envio?.num_presupuesto
                                                )
                                            }
                                        >
                                            <span className="link">
                                                {envio?.num_presupuesto}
                                            </span>
                                        </p>
                                    )}
                                    {envio?.incidencia_id && (
                                        <p
                                            className="m-0"
                                            onClick={() =>
                                                handleGoTo(
                                                    'incidencia',
                                                    envio?.num_incidencia
                                                )
                                            }
                                        >
                                            <span className="link">
                                                {envio?.num_incidencia}
                                            </span>
                                        </p>
                                    )}
                                </td>
                                <td className="text-center" colSpan={3}>
                                    <div className="d-flex flex-column">
                                        {envio?.servicio_envio_nombre}
                                        {envio?.transportista_id === 2 ? (
                                            <a
                                                href={
                                                    'https://www.expressway.es/tracker.php?ref=&alb=' +
                                                    envio?.numero_seguimiento
                                                }
                                                rel="noreferrer"
                                                target="_blank"
                                                className="text-info"
                                            >
                                                {envio?.numero_seguimiento}
                                            </a>
                                        ) : (
                                            <>
                                                <span className="d-block text-info">
                                                    {envio?.numero_seguimiento}
                                                </span>
                                                {envio?.numero_seguimiento && (
                                                    <span
                                                        title="Estado"
                                                        onClick={() =>
                                                            handleOpenStatus(
                                                                envio
                                                            )
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faLink}
                                                            size="1x"
                                                            className="action"
                                                            color="#215732"
                                                        ></FontAwesomeIcon>
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </td>
                                {currentDetail?.estadoNombre ===
                                    'Cancelado' && (
                                    <td className="text-center" colSpan={2}>
                                        <div className="w-100 d-flex flex-column">
                                            <span className="fw-bold text-uppercase ">
                                                {moment(
                                                    envio?.fecha_cancelado
                                                ).format('DD-MM-YYYY')}
                                            </span>
                                            {envio?.motivo_cancelado && (
                                                <CustomTooltip
                                                    title={
                                                        <p className="m-0">
                                                            {
                                                                envio?.motivo_cancelado
                                                            }
                                                        </p>
                                                    }
                                                >
                                                    <span
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <InfoOutlined
                                                            sx={{
                                                                color: '#215731',
                                                                fontSize: 18,
                                                            }}
                                                        />
                                                    </span>
                                                </CustomTooltip>
                                            )}
                                        </div>
                                    </td>
                                )}
                                {!currentDetail && (
                                    <td
                                        className="text-center text-uppercase"
                                        colSpan={2}
                                    >
                                        {envio?.estadoNombre}
                                    </td>
                                )}
                                <td
                                    className="text-center text-uppercase"
                                    colSpan={2}
                                >
                                    {envio?.created_by_username}
                                </td>
                                <td className="text-center" colSpan={1}>
                                    <ActionsMenu
                                        options={getActions(envio)}
                                        onAction={(action) =>
                                            handleAction(action, envio)
                                        }
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex justify-content-end">
                    <Pagination
                        className="mt-3"
                        count={getPaginationCount()}
                        page={currentPage}
                        onChange={handleChangePage}
                    />
                </div>
            </div>

            {openInfo && (
                <InfoModal
                    state={openInfo}
                    title={
                        'Información de envío ' +
                        currentEnvio?.codigo_transporte
                    }
                    width={'md'}
                    content={<EnvioDetail envio={currentEnvio} />}
                    onClose={handleCloseOpenInfo}
                />
            )}

            {openSeguimientoEnvio && (
                <InfoModal
                    state={openSeguimientoEnvio}
                    title={`${
                        openSeguimientoEnvio === 'edit' ? 'Editar' : 'Añadir'
                    } información de seguimiento envío ${
                        currentEnvio?.codigo_transporte
                    }`}
                    width={'sm'}
                    content={
                        openSeguimientoEnvio === 'edit' ? (
                            <UpdateSeguimientoForm envio={currentEnvio} />
                        ) : (
                            <SeguimientoForm
                                envioId={currentEnvio?.id}
                                envio={currentEnvio}
                                onSubmitSeguimiento={handleAddSeguimientoEnvio}
                            />
                        )
                    }
                    onClose={handleCloseAddSeguimiento}
                />
            )}

            {openCancelar && (
                <InfoModal
                    state={openCancelar}
                    title={'Cancelar envío ' + currentEnvio?.codigo_transporte}
                    width={'md'}
                    content={
                        <MessageForm
                            envioId={currentEnvio?.id}
                            onSubmitMessage={handleCancelarEnvio}
                        />
                    }
                    onClose={handleCloseCancelar}
                />
            )}

            {openStatus && (
                <InfoModal
                    state={openStatus}
                    title={'Estado de envío ' + currentEnvio?.codigo_transporte}
                    width={'md'}
                    content={
                        <EnvioEstadoModal
                            lastStatus={currentDetail?.estadoId}
                            envio={currentEnvio}
                        />
                    }
                    onClose={handleCloseStatus}
                />
            )}

            {openRegenerate && (
                <ConfirmModal
                    onConfirmAction={handleConfirmRegenerate}
                    title={'Regenerar envío ' + currentEnvio?.codigo_transporte}
                    description={'Estás seguro de regenerar el envío?'}
                    state={openRegenerate}
                ></ConfirmModal>
            )}

            {openUpdateState && (
                <InfoModal
                    state={openUpdateState}
                    title={
                        'Actualizar estado de envío ' +
                        currentEnvio?.codigo_transporte
                    }
                    width={'xs'}
                    content={
                        <UpdateEstadoForm
                            envioId={currentEnvio?.id}
                            currentEstado={currentDetail?.estadoId}
                            updateReduxState={updateReduxState}
                            handleCloseUpdateState={handleCloseUpdateState}
                        />
                    }
                    onClose={handleCloseUpdateState}
                />
            )}
        </div>
    );
}
